import { render } from "./prescription-item.vue?vue&type=template&id=18d3b84e&scoped=true"
import script from "./prescription-item.vue?vue&type=script&lang=js"
export * from "./prescription-item.vue?vue&type=script&lang=js"

import "./prescription-item.vue?vue&type=style&index=0&id=18d3b84e&lang=scss&scoped=true"

import exportComponent from "/builds/gitlab-runner/ci/auto-build/hospital-user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18d3b84e"]])

export default __exports__